export var getChat = function (state) { return state.chat; };
export var getChatIsModalOpen = function (state) { return state.chat.isModalOpen; };
